export default class AdresseSuggestionsApiDriveService {
  path = "/api";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  async fetchAdresseSuggestions(params = { code_insee: "", recherche_adresse: "" }) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/adresseSuggestions`, config);
    return res.data;
  }

  async fetchAdresseCommunes(params = { code_postal: "" }) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/adresseSuggestions/communes`, config);
    return res.data;
  }

  async fetchAdresseComplements(params = { id_voie: "", id_num: "" }) {
    const config = {
      ...this.httpApi.getConfig(),
      params: {
        id_num: params.id_num
      }
    };
    const res = await this.httpApi.get(`${this.path}/adresseSuggestions/${params.id_voie}/complements`, config);
    return res.data;
  }

  async fetchAdresseRnvp(params = { adresse: "" }) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/adresseSuggestions/rnvp`, config);
    return res.data;
  }
}
